import * as React from 'react';
import { Theme } from '@mui/styles';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import {Button} from '@mui/material';
import { Typography } from '@mui/material';
import {Dialog, DialogTitle, DialogContent, DialogActions, FormControl, FormLabel, FormGroup} from '@mui/material';
import {Grid} from '@mui/material';
import {StringAttribute} from '../../../common/lib/types'

type State = {
   open: boolean;
//    confirmData: confirmForm;
};

interface Props extends React.HTMLProps<HTMLDivElement> {
   classes: any;
   open: boolean;
   title: string;
   confirmMessage: string;
   handleYes: ()=>void
   handleNo: ()=>void
  }

  const styles = (theme:Theme):StyleRules => ({
    modalContent: {
        width: 500
    },
    actionAutoConfirmButtonClass:{
        border: 'dashed 1px #dedede'
    },
    modalTitle: {
        padding: "0px 0px 20px 0px"
    },
    gridItem: {
        paddingBottom: "0px !important;",
        paddingTop: "0px !important;"
    },
    controlContainer: {
        width: "100%",
        padding: 0
    },
    dangerButton: {
        backgroundColor: "#af0202",
        '&:hover': {
            backgroundColor: "#5D0A0A !important"
        }
    },
    compactLabel: {
        fontSize: '0.75rem !important'
      },
})

class UserQueryViewConfirmActionModal extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
    constructor(props: Props) {
        super(props, {});
        this.state = {
            open: props.open,
        }
      }

   componentDidMount() {
  
    
    }

    componentWillUnmount() {
        
    }



    handleDispatch = () => {
        this.props.handleYes()
    }

  
    closeDialog = () => {
        this.handleClose({}, "")
    }

    handleClose = (event, reason) => {
      this.props.handleNo()
    }

    render() {
        const { classes }: { classes: ClassNameMap;} = this.props;
        
        const {open} = this.state

        const {user} = this.props
        
        return (
            <Dialog
                className={classes.modal}
                open={open}
                onClose={this.handleClose}
            >   
                <DialogContent className={classes.modalContent}>
                    <DialogTitle className={classes.modalTitle}>
                        {this.props.title}
                    </DialogTitle>  
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Typography dangerouslySetInnerHTML={{ __html: this.props.confirmMessage}} variant="subtitle1"></Typography> 
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <FormControl
                                className={classes.formDefClass}>
                                <FormLabel className={classes.compactLabel}>
                                    User Name
                                </FormLabel>
                                <FormGroup>
                                    {user.userName} 
                                </FormGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <FormControl
                                className={classes.formDefClass}>
                                <FormLabel className={classes.compactLabel}>
                                    First Name
                                </FormLabel>
                                <FormGroup>
                                    {user.firstName}
                                </FormGroup>
                            </FormControl>
                            <FormControl
                                style={{marginLeft: 10}}
                                className={classes.formDefClass}>
                                <FormLabel className={classes.compactLabel}>
                                    Last Name
                                </FormLabel>
                                <FormGroup>
                                    {user.lastName} 
                                </FormGroup>
                            </FormControl>		
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <FormControl
                                className={classes.formDefClass}>
                                <FormLabel className={classes.compactLabel}>
                                    Email Address
                                </FormLabel>
                                <FormGroup>
                                    {user.emailAddress} 
                                </FormGroup>
                            </FormControl>		
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button 
                        variant="contained"
                        color="inherit"
                        onClick={this.closeDialog}>
                        No
                    </Button>
                    <Button 
                        autoFocus={true}
                        variant="contained"
                        color="primary"
                        className={classes.actionAutoConfirmButtonClass} 
                        onClick={this.handleDispatch}>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default withStyles(styles)(UserQueryViewConfirmActionModal);